module.exports = __webpack_public_path__ + "img/ltkxprime-1x.d25219b.jpg";